export default {
    install(Vue, options) {
        Vue.dingGenerateLocalId = function() {
            return 'local-' + (new Date()).getTime() + Math.random() * 10000;
        };

        Vue.dingIsLocalId = function(id) {
            return id && id.match && id.match(/^local-/);
        };

        Vue.dingImgUrlWithContext = function(context, imageFileName) {
            return context.storageEndpoint + imageFileName;
        };

        Vue.dingMapWithGivenKey = function(array, key) {
            if (!array) {
                return {};
            }
            var map = {};
            for (var i in array) {
                var item = array[i];
                map[item[key]] = item;
            }
            return map;
        }

        Vue.filter('toCurrency', (value) => {
            if (value >= 0) {
                return `$${value}`;
            } else {
                return `-$${Math.abs(value)}`;
            }
        });
    }
};
